module.exports = __webpack_public_path__ + "img/trinapp_launchpad_navigation-graph.672d2ebb.png";